import React from 'react';
import { Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { usePermission, Permissions } from '@billda/permissions-ui';
import { useGetCompanyDetails } from '../hooks/useCompanyDetails';

export function useCompanyDetailsMissing(): boolean {
  const { data, isLoading } = useGetCompanyDetails();
  return !isLoading && data?.isConfigured === false;
}

export const CompanyDetailsBanner: React.FC = () => {
  const navigate = useNavigate();
  const canRead = usePermission(Permissions.Organisation.Details.Read);
  const canManage = usePermission(Permissions.Organisation.Details.Manage);
  const missing = useCompanyDetailsMissing();

  if (!canRead || !missing) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      data-testid="company-details-banner"
      sx={canManage ? { cursor: 'pointer' } : undefined}
      onClick={canManage ? () => navigate('/settings') : undefined}
    >
      {canManage
        ? 'Complete your organisation details to approve and pay pots'
        : 'Organisation details are incomplete — contact your organisation owner'}
    </Alert>
  );
};
